// libs
import * as React from 'react'

// interfaces / constants
import { THUMBNAIL_SIZE_TYPE_SMALL } from 'src/components/thumbnail/thumbnail'
import { CLASS_PREFIX } from 'src/constants/'

// components
import Avatar from 'src/components/avatar/avatar'

// helpers
import { CommentDeletionReason, CommentFragmentFragment } from '@lopo-tech/lopo-api'
import { textResources } from 'src/lang/de'
import DateFormatter from 'src/utils/date_formatter/date_formatter'
import * as avatarPath from './avatar-deleted-profile.svg'
import './deleted_comment.scss'

const labels = textResources.comments
const cls = CLASS_PREFIX + 'deleted-comment'

const getDeletedByTranslation = (deletedBy: CommentDeletionReason) => {
  switch (deletedBy) {
    case CommentDeletionReason.PlatformModeration:
      return labels.removedByAdmin_WEB
    case CommentDeletionReason.Author:
      return labels.removedByAuthor
    case CommentDeletionReason.CommentableAuthor:
      return labels.removedByCommentableAuthor_WEB
    default:
      return labels.removedByUnknown
  }
}

interface IDeletedComment {
  comment: CommentFragmentFragment
}

const DeletedComment: React.FC<IDeletedComment> = ({ comment }) => {
  return (
    <div className={cls}>
      <div className={cls + '__avatar'}>
        <Avatar image={avatarPath} size={THUMBNAIL_SIZE_TYPE_SMALL} withBorder />
      </div>
      <div className={cls + '__body'}>
        {comment.deletionReason
          ? <div className={cls + '__message'}>
            {getDeletedByTranslation(comment.deletionReason)}
          </div>
          : null}
        <div className={cls + '__footer'}>
          <div className={cls + '__reactions'} />
          <div className={cls + '__date'}>
            {DateFormatter.asTimeAgo(comment.updatedAt)}
          </div>
          <div className={cls + '__more-button'} />
        </div>
      </div>
    </div>
  )
}

export default DeletedComment
